import { render, staticRenderFns } from "./DoctorInfoModal.vue?vue&type=template&id=55d77744&scoped=true"
import script from "./DoctorInfoModal.vue?vue&type=script&lang=js"
export * from "./DoctorInfoModal.vue?vue&type=script&lang=js"
import style0 from "./DoctorInfoModal.vue?vue&type=style&index=0&id=55d77744&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d77744",
  null
  
)

export default component.exports